import React from 'react';

const UserFullName = ({ user }) => {
  if (!user) {
    return <span>System generated</span>;
  }

  return (
    <span>
      {user.firstName} {user.lastName}
    </span>
  );
};

export default UserFullName;



// WEBPACK FOOTER //
// ./src/components/userFullname/userFullname.jsx